import en from "./locales/en.json";
import tr from "./locales/translations.json";
import { useLang } from "@/i18n";

export function useM() {
  const { lang } = useLang();
  return (k) => (tr[lang] && tr[lang][k]) || en[k] || k;
}
